<template>
  <b-sidebar
    no-header
    no-header-close
    no-close-on-backdrop
    no-close-on-esc
    no-close-on-route-change
    id="sidebar"
    class="mc-sidebar-liveview"
    :class="{
      'close-history-sidebar': $store.state.map.modalFleetHistory === true,
      '': $store.state.map.modalFleetHistory === false,
    }"
  >
    <span class="mc-sidebar-toggle" @click="toggleSideBar">
      <i class="mc-fa fas fa-angle-left"></i>
      <i class="mc-fa icon-outline_close"></i>
      <u></u>
    </span>

    <div class="mc-sidebar-liveview__wrapper">
      <ListFleet />
    </div>
  </b-sidebar>
</template>

<script>
import ListFleet from "./Fleets/ListFleet";
import responsive from "@/mixin/responsive";

export default {
  name: "SideBar",
  mixins: [responsive],
  components: {
    ListFleet,
  },
  created() {
    if (this.mediaQuery.matches && this.$store.state.sidebar.sideBarOpen) {
      this.toggleSideBar();
    }
  },
  methods: {
    changeMap(type) {
      const data = {
        zoom: 5.56,
        open: false,
        gmp: null,
        type: type,
      };

      this.$store.dispatch("map/setCENTER", data);
    },
    toggleSideBar() {
      this.$store.commit("sidebar/toggleSideBar");
      if (this.mediaQuery.matches) {
        this.$store.dispatch("map/closeInfo", false);
      }
    },
  },
};
</script>